import { SuspendPraticaStepStatusEnum } from "@api/client";
import { Step } from "layout/models/step.model";

export const getIconStepStyle = (activeIndex?: number, stepIndex?: number, endStep?: boolean) => {
	if (activeIndex != undefined && stepIndex != undefined) {
		if (activeIndex == stepIndex) {
			return "current-step-icon";
		} else if (endStep || activeIndex > stepIndex) {
			return "complete-step-icon";
		}
	}

	return "todo-step-icon";
};

export namespace LayoutUtils {
	export const getLastStepBackendRef = (
		steps: Step[] | undefined,
		locationPath: string
	): SuspendPraticaStepStatusEnum => {
		if (!steps) throw "No Steps send";

		const currentStep = steps?.find(
			(s) => s.route == locationPath || s?.subSteps?.find((ss) => ss?.route == locationPath)
		);

		if (currentStep?.backendEnumRef) return currentStep?.backendEnumRef;
		else {
			const currentSubStep = currentStep?.subSteps?.find((ss) => ss?.route == locationPath);

			if (currentSubStep?.backendEnumRef) return currentSubStep?.backendEnumRef;
		}

		const currentStepIndex = steps?.findIndex((s) => s.route == currentStep?.route);

		let backendEnumRef: SuspendPraticaStepStatusEnum = SuspendPraticaStepStatusEnum.AvviaPratica;

		let _steps = [...steps];

		let lastStep = _steps?.reverse()?.find((s, i) => {
			return (
				i >= steps?.length - currentStepIndex - 1 &&
				(s?.backendEnumRef || s?.subSteps?.find((ss) => ss?.backendEnumRef))
			);
		});

		if (lastStep?.subSteps) {
			let lastSubsteps = [...lastStep?.subSteps];

			let lastSubstep = lastSubsteps?.reverse().find((s) => s?.backendEnumRef);

			if (lastSubstep?.backendEnumRef) backendEnumRef = lastSubstep?.backendEnumRef;
		}

		if (lastStep?.backendEnumRef) backendEnumRef = lastStep?.backendEnumRef;

		return backendEnumRef;
	};
}
